import axios from "axios";
import {useState} from "react";

const useAnalytic = (formData: any, temp: any) => {
  const [analytic, setAnalytic] = useState({
    expected: temp.fund_port.stat.expected,
    sd: temp.fund_port.stat.sd,
    maxdd: -1,
    vcar: -1,
  });

  const analyzePort = async () => {
    let device_id = localStorage.getItem("device_id");
    const url = "https://fhc.insuretechthailand.com/ins/funds/cal";
    const info = {
      device_id: device_id, // device_id ของ local
      cal_type: "port_analyze", // function ที่เรียกใช้
      port: formData.selectedAssetList,
      time: Date.now(),
      calculateAT: new Date().toLocaleString(),
    };
    const response = await axios.post(url, info);
    if (!!response.data.data) {
      setAnalytic({...response.data.data});
    }
  };

  const analyzedData = [
    {
      name: "ผลตอบเทนที่คาดหวัง",
      englishName: "Expected Return",
      value: analytic.expected.toString(),
    },
    {
      name: "ความผันผวน",
      englishName: "(S.D.)",
      value: analytic.sd.toString(),
    },
    {
      name: "ผลตอบแทนขาดทุนสูงสุด",
      englishName: "(Max. Drawdown)",
      value: !!analytic.maxdd ? analytic.maxdd.toString() : "-",
    },
    {
      name: "ค่าความเสี่ยงแบบมีเงื่อนไข",
      englishName: "(CVaR)",
      value: !!analytic.vcar ? analytic.vcar.toString() : "-",
    },
  ];

  return {analyzePort, analyzedData, analytic};
};

export default useAnalytic;
